import {
  GET_DAILYDEMAND_REQUEST,
  GET_DAILYDEMAND_SUCCESS,
  GET_DAILYDEMAND_FAILURE,
  GET_MONTHLYDEMAND_REQUEST,
  GET_MONTHLYDEMAND_SUCCESS,
  GET_MONTHLYDEMAND_FAILURE,
  GET_PARTNO_REQUEST,
  GET_PARTNO_SUCCESS,
  GET_PARTNO_FAILURE,
  GET_PLANT_REQUEST,
  GET_PLANT_SUCCESS,
  GET_PLANT_FAILURE,
  GET_PACKAGE_TYPE_REQUEST,
  GET_PACKAGE_TYPE_SUCCESS,
  GET_PACKAGE_TYPE_FAILURE,
  POST_CALCULATE_PACKAGE_DETAILS_REQUEST,
  POST_CALCULATE_PACKAGE_DETAILS_SUCCESS,
  POST_CALCULATE_PACKAGE_DETAILS_FAILURE,
  GET_DELIVERY_PLANT_REQUEST,
  GET_DELIVERY_PLANT_SUCCESS,
  GET_DELIVERY_PLANT_FAILURE,
  GET_UNLOADING_POINT_REQUEST,
  GET_UNLOADING_POINT_SUCCESS,
  GET_UNLOADING_POINT_FAILURE,
  GET_CALCULATE_PACKAGE_WEIGHT_REQUEST,
  GET_CALCULATE_PACKAGE_WEIGHT_SUCCESS,
  GET_CALCULATE_PACKAGE_WEIGHT_FAILURE,
  GET_BINS_FOR_PRINT_REQUEST,
  GET_BINS_FOR_PRINT_SUCCESS,
  GET_BINS_FOR_PRINT_FAILURE,
  GET_UNCONFIRMED_MONTHLYDEMAND_REQUEST,
  GET_UNCONFIRMED_MONTHLYDEMAND_SUCCESS,
  GET_UNCONFIRMED_MONTHLYDEMAND_FAILURE,
  GET_VENDORS_REQUEST,
  GET_VENDORS_SUCCESS,
  GET_VENDORS_FAILURE,
  GET_PARTNO_FOR_PLANNER_REQUEST,
  GET_PARTNO_FOR_PLANNER_SUCCESS,
  GET_PARTNO_FOR_PLANNER_FAILURE,
  GET_VENDORS_WITH_PAGINATION_REQUEST,
  GET_VENDORS_WITH_PAGINATION_SUCCESS,
  GET_VENDORS_WITH_PAGINATION_FAILURE,
  GET_DAILYDEMAND_DOWNLOAD_REQUEST,
  GET_DAILYDEMAND_DOWNLOAD_SUCCESS,
  GET_DAILYDEMAND_DOWNLOAD_FAILURE,
  GET_MONTHLYDEMAND_DOWNLOAD_REQUEST,
  GET_MONTHLYDEMAND_DOWNLOAD_SUCCESS,
  GET_MONTHLYDEMAND_DOWNLOAD_FAILURE,
} from "./newDemandTypes";

const initialStateForDailyDemand = {
  loading: false,
  dailyDemandData: {},
  error: "",
};

const dailyDemandReducer = (state = initialStateForDailyDemand, action) => {
  switch (action.type) {
    case GET_DAILYDEMAND_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DAILYDEMAND_SUCCESS:
      return {
        loading: false,
        dailyDemandData: action.payload,
        error: "",
      };
    case GET_DAILYDEMAND_FAILURE:
      return {
        loading: false,
        dailyDemandData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDailyDemandForDownload = {
  loading: false,
  dailyDemandDataForDownload: {},
  error: "",
};

const dailyDemandForDownloadReducer = (
  state = initialStateForDailyDemandForDownload,
  action
) => {
  switch (action.type) {
    case GET_DAILYDEMAND_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DAILYDEMAND_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        dailyDemandDataForDownload: action.payload,
        error: "",
      };
    case GET_DAILYDEMAND_DOWNLOAD_FAILURE:
      return {
        loading: false,
        dailyDemandDataForDownload: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMonthlyDemand = {
  loading: false,
  monthlyDemandData: {},
  error: "",
};

const monthlyDemandReducer = (state = initialStateForMonthlyDemand, action) => {
  switch (action.type) {
    case GET_MONTHLYDEMAND_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MONTHLYDEMAND_SUCCESS:
      return {
        loading: false,
        monthlyDemandData: action.payload,
        error: "",
      };
    case GET_MONTHLYDEMAND_FAILURE:
      return {
        loading: false,
        monthlyDemandData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};


const initialStateForMonthlyDemandDownload = {
  loading: false,
  monthlyDemandData: {},
  error: "",
};

const monthlyDemandDownloadReducer = (state = initialStateForMonthlyDemandDownload, action) => {
  switch (action.type) {
    case GET_MONTHLYDEMAND_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_MONTHLYDEMAND_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        monthlyDemandData: action.payload,
        error: "",
      };
    case GET_MONTHLYDEMAND_DOWNLOAD_FAILURE:
      return {
        loading: false,
        monthlyDemandData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPartNoForPlanner = {
  loading: false,
  partNoForPlannerData: {},
  error: "",
};

const partNoForPlannerReducer = (
  state = initialStateForPartNoForPlanner,
  action
) => {
  switch (action.type) {
    case GET_PARTNO_FOR_PLANNER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PARTNO_FOR_PLANNER_SUCCESS:
      return {
        loading: false,
        partNoForPlannerData: action.payload,
        error: "",
      };
    case GET_PARTNO_FOR_PLANNER_FAILURE:
      return {
        loading: false,
        partNoForPlannerData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPartNo = {
  loading: false,
  partNoData: {},
  error: "",
};

const partNoReducer = (state = initialStateForPartNo, action) => {
  switch (action.type) {
    case GET_PARTNO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PARTNO_SUCCESS:
      return {
        loading: false,
        partNoData: action.payload,
        error: "",
      };
    case GET_PARTNO_FAILURE:
      return {
        loading: false,
        partNoData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPlant = {
  loading: false,
  plantData: {},
  error: "",
};

const plantReducer = (state = initialStateForPlant, action) => {
  switch (action.type) {
    case GET_PLANT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PLANT_SUCCESS:
      return {
        loading: false,
        plantData: action.payload,
        error: "",
      };
    case GET_PLANT_FAILURE:
      return {
        loading: false,
        plantData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForVendorsListForPlanner = {
  loading: false,
  vendorsListForPlannerData: {},
  error: "",
};

const vendorsListForPlannerReducer = (
  state = initialStateForVendorsListForPlanner,
  action
) => {
  switch (action.type) {
    case GET_VENDORS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDORS_SUCCESS:
      return {
        loading: false,
        vendorsListForPlannerData: action.payload,
        error: "",
      };
    case GET_VENDORS_FAILURE:
      return {
        loading: false,
        vendorsListForPlannerData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPackageType = {
  loading: false,
  packageTypeData: {},
  error: "",
};

const packageTypeReducer = (state = initialStateForPackageType, action) => {
  switch (action.type) {
    case GET_PACKAGE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PACKAGE_TYPE_SUCCESS:
      return {
        loading: false,
        packageTypeData: action.payload,
        error: "",
      };
    case GET_PACKAGE_TYPE_FAILURE:
      return {
        loading: false,
        packageTypeData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUnloadingPoint = {
  loading: false,
  unloadingPointData: {},
  error: "",
};

const unloadingPointReducer = (
  state = initialStateForUnloadingPoint,
  action
) => {
  switch (action.type) {
    case GET_UNLOADING_POINT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_UNLOADING_POINT_SUCCESS:
      return {
        loading: false,
        unloadingPointData: action.payload,
        error: "",
      };
    case GET_UNLOADING_POINT_FAILURE:
      return {
        loading: false,
        unloadingPointData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDeliveryPlant = {
  loading: false,
  deliveryPlantData: {},
  error: "",
};

const deliveryPlantReducer = (state = initialStateForDeliveryPlant, action) => {
  switch (action.type) {
    case GET_DELIVERY_PLANT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DELIVERY_PLANT_SUCCESS:
      return {
        loading: false,
        deliveryPlantData: action.payload,
        error: "",
      };
    case GET_DELIVERY_PLANT_FAILURE:
      return {
        loading: false,
        deliveryPlantData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPacketWeight = {
  loading: false,
  packetWeightData: {},
  error: "",
};

const packetWeightReducer = (state = initialStateForPacketWeight, action) => {
  switch (action.type) {
    case GET_CALCULATE_PACKAGE_WEIGHT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CALCULATE_PACKAGE_WEIGHT_SUCCESS:
      return {
        loading: false,
        packetWeightData: action.payload,
        error: "",
      };
    case GET_CALCULATE_PACKAGE_WEIGHT_FAILURE:
      return {
        loading: false,
        packetWeightData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPackageDetails = {
  loading: false,
  packageDetailsData: {},
  error: "",
};

const packageDetailsReducer = (
  state = initialStateForPackageDetails,
  action
) => {
  switch (action.type) {
    case POST_CALCULATE_PACKAGE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case POST_CALCULATE_PACKAGE_DETAILS_SUCCESS:
      return {
        loading: false,
        packageDetailsData: action.payload,
        error: "",
      };
    case POST_CALCULATE_PACKAGE_DETAILS_FAILURE:
      return {
        loading: false,
        packageDetailsData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForBinsForPrint = {
  loading: false,
  binsForPrintData: {},
  error: "",
};

const binsForPrintReducer = (state = initialStateForBinsForPrint, action) => {
  switch (action.type) {
    case GET_BINS_FOR_PRINT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_BINS_FOR_PRINT_SUCCESS:
      return {
        loading: false,
        binsForPrintData: action.payload,
        error: "",
      };
    case GET_BINS_FOR_PRINT_FAILURE:
      return {
        loading: false,
        binsForPrintData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUnConfirmedMonthlyDemand = {
  loading: false,
  unConfirmedMonthlyDemandData: {},
  error: "",
};

const unConfirmedMonthlyDemandReducer = (
  state = initialStateForUnConfirmedMonthlyDemand,
  action
) => {
  switch (action.type) {
    case GET_UNCONFIRMED_MONTHLYDEMAND_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_UNCONFIRMED_MONTHLYDEMAND_SUCCESS:
      return {
        loading: false,
        unConfirmedMonthlyDemandData: action.payload,
        error: "",
      };
    case GET_UNCONFIRMED_MONTHLYDEMAND_FAILURE:
      return {
        loading: false,
        unConfirmedMonthlyDemandData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForVendorsListForPlannerWithPagination = {
  loading: false,
  vendorsListForPlannerData: {},
  error: "",
};

const vendorsListForPlannerWithPaginationReducer = (
  state = initialStateForVendorsListForPlannerWithPagination,
  action
) => {
  switch (action.type) {
    case GET_VENDORS_WITH_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDORS_WITH_PAGINATION_SUCCESS:
      return {
        loading: false,
        vendorsListForPlannerData: action.payload,
        error: "",
      };
    case GET_VENDORS_WITH_PAGINATION_FAILURE:
      return {
        loading: false,
        vendorsListForPlannerData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
export {
  dailyDemandReducer,
  dailyDemandForDownloadReducer,
  monthlyDemandReducer,
  partNoForPlannerReducer,
  partNoReducer,
  plantReducer,
  packageTypeReducer,
  packageDetailsReducer,
  deliveryPlantReducer,
  unloadingPointReducer,
  packetWeightReducer,
  binsForPrintReducer,
  unConfirmedMonthlyDemandReducer,
  vendorsListForPlannerReducer,
  vendorsListForPlannerWithPaginationReducer,
  monthlyDemandDownloadReducer
};
